// NPM
import { defineStore } from 'pinia';

// Services
import Api from '@/services/api';

// Stores
import { useUserStore } from '@/stores/user';
import type {
  UserDashboardGetAllChallengesResponseType,
  UserDashboardStartChallengeResponseType,
} from '@magma-app/magma-types/all';

export const useChallengesStore = defineStore('challenges', {
  state: () => {
    return {
      availableChallenges:
        [] as UserDashboardGetAllChallengesResponseType['available'],
      completedChallenges:
        [] as UserDashboardGetAllChallengesResponseType['validated'],
      uncompletedChallenges:
        [] as UserDashboardGetAllChallengesResponseType['ongoing'],
      displayCompletedChallengeDetails: false,
      displayChallengeDetails: false,
    };
  },

  actions: {
    setCompletedChallengeDetails(displayCompletedChallengeDetails: boolean) {
      this.displayCompletedChallengeDetails = displayCompletedChallengeDetails;
    },

    setChallengeDetails(displayChallengeDetails: boolean) {
      this.displayChallengeDetails = displayChallengeDetails;
    },

    async getChallenges() {
      const response = await Api.userDashboard().challenges.getChallenges();

      this.completedChallenges = response.data.available;
      this.uncompletedChallenges = response.data.ongoing;
      this.availableChallenges = response.data.available;
    },

    async accomplishChallenge(userChallengeId: number) {
      const response = await Api.userDashboard().challenges.accomplishChallenge(
        { userChallengeId }
      );

      const challengeIndex = this.uncompletedChallenges.findIndex(
        (challenge) => {
          return challenge.userChallengeId === userChallengeId;
        }
      );

      this.uncompletedChallenges.splice(challengeIndex, 1);
      this.completedChallenges.push(response.data);

      if (response.data.status === 'validated') {
        const userStore = useUserStore();
        const userBalance =
          (userStore.user?.balance || 0) + response.data.points;
        userStore.updateUserBalance(userBalance);
      }
    },

    async startChallenge(challengeId: number) {
      const response = await Api.userDashboard().challenges.startChallenge({
        challengeId,
      });

      const challengeIndex = this.uncompletedChallenges.findIndex(
        (challenge) => {
          return challenge.challengeId === challengeId;
        }
      );

      this.uncompletedChallenges.splice(
        challengeIndex,
        1,
        response.data as UserDashboardStartChallengeResponseType
      );
    },
  },
});
